var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgMainLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 573,
    viewBox: "0 0 308 573",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_180_2337)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.5,
    cy: 473.5,
    rx: 67.5,
    ry: 128.5,
    fill: "#1EBBE2",
    fillOpacity: 0.66
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_180_2337)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.5,
    cy: 263,
    rx: 67.5,
    ry: 63,
    fill: "#E2C51E",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_180_2337",
    x: -227,
    y: 145,
    width: 535,
    height: 657,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_180_2337"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_180_2337",
    x: -245,
    y: 0,
    width: 535,
    height: 526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_1800_2337"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgMainLayout);
export default __webpack_public_path__ + "static/media/bg-main-layout.f0a9bba8452e8ee8eaffc052a005e8d3.svg";
export { ForwardRef as ReactComponent };